var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Big_Icons",
    "data-name": "Big Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CRM"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.673,47a19.327,19.327,0,1,1,38.654,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25,
    cy: 15.734,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3_copy",
    "data-name": "Ellipse 3 copy",
    className: "cls-3",
    d: "M16.78,21.468a10.028,10.028,0,1,1,18.234-5.741"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.8667022c85684a53954113f46574abcd.svg";
export { ForwardRef as ReactComponent };